export const groupByAlpha = (users) => {
  const groups = {};
  users.forEach((user) => {
    const letter = user.name[0].toUpperCase();
    if (!groups[letter]) groups[letter] = [];
    groups[letter].push(user);
  });
  return groups;
};